import { useCallback } from "react";
import { trpc } from "../../../lib/api/trpc";

/**
 * Hook for deleting a user
 */
export const useDeleteUser = () => {
  // Get the trpc context for revalidating queries
  // @ts-ignore - Type checking for trpc.useContext
  const utils = trpc.useContext();

  // Delete user mutation
  // @ts-ignore - Type checking for trpc.user property
  const {
    // mutate, // Commented out as it's not used
    mutateAsync,
    isLoading,
    isError,
    error,
    isSuccess,
    reset,
  } = trpc.user.deleteUser.useMutation({
    onSuccess: () => {
      // Invalidate the users list query to refresh data
      // @ts-ignore - Type checking for utils.user property
      utils.user.getUsers.invalidate();
    },
  });

  // Function to delete a user with better error handling
  const deleteUser = useCallback(
    async (userId: string) => {
      try {
        await mutateAsync({ id: userId });
        return { success: true };
      } catch (err: any) {
        return {
          success: false,
          error: err?.message || "Failed to delete user",
        };
      }
    },
    [mutateAsync],
  );

  return {
    deleteUser,
    isLoading,
    isError,
    error,
    isSuccess,
    reset,
  };
};
